// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading2_element__o_xqX"};